import React, { useEffect, useState } from "react";
import ProjectGlobalSidebar from "./ProjectGlobalSidebar";
import Sidebar from "./Sidebar";
import TaskHome from "./Tasks/TaskHome";
import TaskDetails from "./Tasks/TaskFormDetails";
import Home from "./Home/Home";
import PDFReport from "../../components/PDFReport";
import Finance from "./Finance/Finance";
import Topbar from "../../components/Topbar";
import Inventory from "./Materials/Material";
import Worker from "./Workers/Worker";
import SiteDetails from "./Site Details/SiteDetails";
import GenerateReportModal from "./Report/GenerateReport";
import { AuthManager } from "utils/authUtils";
import { BASE_URL } from "utils/constant";
import {
  Navigate,
  Route,
  Routes,
  useNavigate,
  useParams,
  useLocation,
} from "react-router-dom";
import SnagsChat from "./Snags/ChatWindow";
import WorkerProfile from "./Workers/WorkerProfile";
import { getFinanceCategories } from "utils/getFinanceCategories";
import DocumentManager from "./Document/DocumentManager";
import BoQ from "./BoQ/BoQ";
import ProjectTeamManagement from "./TeamManagement";

const authManager = new AuthManager(BASE_URL);

// Wrapper to pass route params to WorkerProfile
const WorkerProfileRoute = ({ userPermissions }) => {
  const { siteId, workerId } = useParams();
  const navigate = useNavigate();
  return (
    <WorkerProfile
      workerId={workerId}
      userPermissions={userPermissions}

      onBack={() => navigate(`/site/${siteId}/workers`)}
    />
  );
};

export default function Sitehome({ prepareForLogout }) {
  const { siteId } = useParams();
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState("Home");
  const [delivery, setDelivery] = useState(null);
  const [task, setTask] = useState(null);
  const [snagId, setSnagId] = useState(null);
  const [userPermissions, setUserPermissions] = useState([]);
  const [permissionsLoading, setPermissionsLoading] = useState(true);
  const [triggerRefresh, setTriggerRefresh] = useState(0);
  const [categoryData, setCategoryData] = useState(null);
  const [isProfileCardOpen, setIsProfileCardOpen] = useState(false);
  const [globalSidebarCollapsed, setGlobalSidebarCollapsed] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchCategoryData = async () => {
      const data = await getFinanceCategories();
      setCategoryData(data);
    };
    fetchCategoryData();
  }, []);
  // const setTab = (value) => {
  //   setSelectedTab(value);
  // };

  // async function checkAuth() {
  //   const result = await authManager.initialize();

  //   if (result.status) {
  //     // User is authenticated
  //     console.log("User is authenticated");
  //   } else {
  //     // Handle authentication failure
  //     navigate("/login");
  //     console.log("Authentication failed:", result.error);
  //   }
  // }

  const getUserPermissions = async () => {
    const siteId = localStorage.getItem("site");
    const accessToken = localStorage.getItem("access");

    try {
      const response = await fetch(`${BASE_URL}/team/get-member-permission/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          sites: siteId,
        }),
      });
      const data = await response.json();
      if (data.status) {
        setUserPermissions(data.data);
      } else {
        console.log(data.error);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setPermissionsLoading(false);
    }
  };

  useEffect(() => {
    getUserPermissions();
  }, [localStorage.getItem("site")]);

  // useEffect(() => {
  //   checkAuth();
  // }, []);

  useEffect(() => {
    if (siteId) {
      localStorage.setItem("site", siteId);
    }
  }, [siteId]);

  // Auto-select snag based on query param when navigating from notifications
  useEffect(() => {
    try {
      const params = new URLSearchParams(location.search);
      const paramSnagId = params.get("snagId");
      if (paramSnagId) {
        setSnagId(paramSnagId);
      }
    } catch (e) {
      // no-op
    }
  }, [location.search]);

  const setTab = (tabName, options = {}) => {
    const normalizedTab = tabName.toLowerCase();
    const query = options?.memberId
      ? `?memberId=${encodeURIComponent(options.memberId)}&memberRequest=${Date.now()}`
      : "";
    const path =
      normalizedTab === "chats"
        ? `/site/${siteId}/chats/general-updates`
        : `/site/${siteId}/${normalizedTab}`;

    navigate(`${path}${query}`);
  };

  const handleTaskClick = (task) => {
    setTask(task);
    navigate(`/site/${siteId}/task-details`);
  };

  return (
    <div
      className={`relative flex h-screen flex-col overflow-hidden transition-[padding] duration-200 ease-in-out ${
        globalSidebarCollapsed ? "pl-16" : "pl-[220px]"
      }`}
    >
      <ProjectGlobalSidebar
        activeTab="Projects"
        setSidebarCollapsed={setGlobalSidebarCollapsed}
      />
      {/* // <Topbar className="flex-none" prepareForLogout={prepareForLogout} /> */}
      <Topbar
        className="flex-none"
        prepareForLogout={prepareForLogout}
        onProfileToggle={setIsProfileCardOpen}
      />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar
          setTab={setTab}
          siteId={siteId}
          selected={selectedTab}
          className="flex-none"
          triggerRefresh={triggerRefresh}
          setTriggerRefresh={setTriggerRefresh}
          userPermissions={userPermissions}
        />
        <div className="flex-1 overflow-y-scroll h-[90vh] rounded-xl bg-[#F8FAFC] mt-1 mb-2 mr-2">
          <Routes>
            <Route
              index
              element={<Navigate to={`/site/${siteId}/home`} replace />}
            />
            <Route
              path="home"
              element={
                <Home
                  setTab={setTab}
                  userPermissions={userPermissions}
                  setSnagId={setSnagId}
                  triggerRefresh={triggerRefresh}
                  permissionsLoading={permissionsLoading}
                  isProfileCardOpen={isProfileCardOpen}
                />
              }
            />
            <Route
              path="boq"
              element={
                <BoQ
                  userPermissions={userPermissions}
                  setTab={setTab}
                  setDelivery={setDelivery}
                  permissionsLoading={permissionsLoading}
                />
              }
            />
            <Route
              path="tasks"
              element={<TaskHome handleTaskClick={handleTaskClick} />}
            />
            <Route path="pdf" element={<PDFReport />} />
            <Route
              path="finance"
              element={
                <Finance
                  userPermissions={userPermissions}
                  setTab={setTab}
                  setDelivery={setDelivery}
                  permissionsLoading={permissionsLoading}
                />
              }
            />
            <Route
              path="materials/:id?"
              element={
                <Inventory
                  userPermissions={userPermissions}
                  delivery={delivery}
                  setTab={setTab}
                  setDelivery={setDelivery}
                  permissionsLoading={permissionsLoading}
                />
              }
            />
            <Route
              path="workers"
              element={
                <Worker
                  userPermissions={userPermissions}
                  permissionsLoading={permissionsLoading}
                />
              }
            />
            <Route path="workers/:workerId" element={<WorkerProfileRoute userPermissions={userPermissions} />} />
            <Route
              path="details"
              element={<SiteDetails userPermissions={userPermissions} />}
            />
            <Route
              path="report"
              element={
                <GenerateReportModal
                  userPermissions={userPermissions}
                  permissionsLoading={permissionsLoading}
                />
              }
            />
            <Route
              path="teams"
              element={
                <ProjectTeamManagement
                  userPermissions={userPermissions}
                  permissionsLoading={permissionsLoading}
                />
              }
            />
            <Route path="task-details" element={<TaskDetails task={task} />} />
            <Route
              path="chats/:snagRoomId?"
              element={<SnagsChat id={snagId} />}
            />
            <Route path="document-manager" element={<DocumentManager />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
